// extracted by mini-css-extract-plugin
export default {"wrap":"OF-z","fullWidth":"PF-z","hideOnDesktop":"QF-z","content":"RF-z","hasOpenedNav":"SF-z","crumbsList":"TF-z","dropdownsWrap":"UF-z"};